<template>
  <transition name="fade">
    <div v-if="!hidden" class="menubar" role="menubar">
      <slot />
    </div>
  </transition>
</template>

<script lang="ts" setup>
interface Props {
  hidden?: boolean;
}

withDefaults(defineProps<Props>(), {
  hidden: false,
});
</script>

<style lang="scss" scoped>
.menubar {
  @apply border-t border-t-element-neutral bg-white;
  @apply py-5.5 pl-12.5 pr-12.5;
  @apply sticky bottom-0;
  grid-area: bottom;
  z-index: 10;
}
</style>
